/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EsgConsolidationDatapointWithProfileId } from '../../models/esg-consolidation-datapoint-with-profile-id';
import { EsgDisclosureCode } from '../../models/esg-disclosure-code';
import { EsgDisclosureDatapointId } from '../../models/esg-disclosure-datapoint-id';

export interface ConsolidationDatapointByProfileByYearByCodeByDatapointIdList$Params {
  profileId: number;
  year: number;
  code: EsgDisclosureCode;
  dataPointId: EsgDisclosureDatapointId;
}

export function consolidationDatapointByProfileByYearByCodeByDatapointIdList(http: HttpClient, rootUrl: string, params: ConsolidationDatapointByProfileByYearByCodeByDatapointIdList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EsgConsolidationDatapointWithProfileId>>> {
  const rb = new RequestBuilder(rootUrl, consolidationDatapointByProfileByYearByCodeByDatapointIdList.PATH, 'get');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('year', params.year, {});
    rb.path('code', params.code, {});
    rb.path('dataPointId', params.dataPointId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EsgConsolidationDatapointWithProfileId>>;
    })
  );
}

consolidationDatapointByProfileByYearByCodeByDatapointIdList.PATH = '/esg/profile/consolidation/{profileId}/{year}/{code}/datapoint/{dataPointId}';
